<template>
  <ion-page>
    <ion-content>
      <div class="flex h-full flex-col justify-center bg-gradient-to-r from-[#4479AF] to-[#6AAEA3]">
        <div class="flex flex-wrap justify-center p-10">
          <div
            class="font-fredoka font-outline-1 mb-4 w-full text-center text-4xl text-white drop-shadow"
          >
            retry.li
          </div>
          <button
            v-if="!loading"
            class="font-fredoka cursor-pointer rounded-2xl bg-blue-500 px-4 py-2 text-white"
            @click="login"
          >
            Log in
          </button>
          <div v-else>
            <Loader class="h-6 w-6 animate-spin text-white" />
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { onMounted, ref, watch } from 'vue';
import { IonContent, IonPage } from '@ionic/vue';
import { Capacitor } from '@capacitor/core';
import {
  GoogleAuthProvider,
  getRedirectResult,
  signInWithPopup,
  signInWithCredential,
} from 'firebase/auth';
import { useCurrentUser, useFirebaseAuth } from 'vuefire';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { Loader } from 'lucide-vue-next';

const router = useRouter();
const loading = ref(true);
const auth = useFirebaseAuth();
const user = useCurrentUser();

async function login() {
  if (auth == null) {
    return;
  }

  const provider = new GoogleAuthProvider();

  if (Capacitor.isNativePlatform()) {
    const response = await FirebaseAuthentication.signInWithGoogle();
    const credential = GoogleAuthProvider.credential(response.credential?.idToken);
    await signInWithCredential(auth, credential);
    return;
  }

  signInWithPopup(auth, provider).catch((reason) => {
    console.error('Failed signin', reason);
  });
}

onMounted(async () => {
  if (auth != null) {
    getRedirectResult(auth)
      .then((_) => {
        loading.value = false;
      })
      .catch((reason) => {
        console.error('Failed redirect result', reason);
        loading.value = false;
      });
  } else {
    loading.value = false;
  }

  if (user.value) {
    await router.push('/home');
  }
});

watch(user, () => {
  if (user.value) {
    router.push('/home');
  }
});
</script>
